#import "../fragments/account-info-fragment.graphql"

mutation UpdateAccountInfo($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...AccountInfoFragment
        }
    }
}
